Button = require 'components/common/button'
ConfirmationModal = require 'components/common/confirmation_modal'
ConnectStore = require 'components/enhancers/connect_store'
EtdStore = require 'stores/etd_store'
mediator = require 'mediator'
{ useState } = React
{ useCoffeeCallback, useI18n } = require 'lib/react_utils'

storeConnectors =
  EtdStore: (Store) ->
    presentationType: Store.getPresentationType()
    recommendationId: Store.getEtdId()

GeneratePlrButton = ({ hasRecommendation, presentationType, questionId, recommendationId }) ->
  i18n = useI18n 'es:recommendations.presentations'
  [isModalOpen, setIsModalOpen] = useState false
  [isLoading, setIsLoading] = useState false

  showButton = mediator.services.switches.isOn('premium-presentations') and
    mediator.services.switches.isOn('plr-generator') and
    presentationType is 'premium-patients'

  onOpenModal = useCoffeeCallback [isLoading], ->
    return if isLoading
    setIsModalOpen true

  onCloseModal = useCoffeeCallback [isLoading], ->
    return if isLoading
    setIsModalOpen false

  onConfirm = useCoffeeCallback [questionId, recommendationId, i18n], ->
    setIsLoading true
    mediator.services.aiService.generatePlrForQuestion questionId, { recommendationId }
    .then ->
      mediator.dialogs.success i18n 'generate_plr.success'
    .catch (error) ->
      mediator.dialogs.error error?.message or i18n 'generate_plr.error'
    .finally ->
      setIsLoading false
      setIsModalOpen false

  <React.Fragment>
    <span className="toolbar-separator" />
    {showButton and
      <Button
        className="generate-plr"
        disabled={isLoading or not hasRecommendation}
        label={i18n 'generate_plr.button'}
        onClick={onOpenModal}
        shape="pill"
        title={i18n 'generate_plr.button'}
        type="button"
      />
    }
    <ConfirmationModal
      cancelLabel={i18n '/actions.cancel'}
      confirmLabel={i18n 'generate_plr.confirmation_apply'}
      isCancelEnabled={not isLoading}
      isOpen={isModalOpen}
      loading={isLoading}
      message={i18n 'generate_plr.confirmation_message'}
      onCancel={onCloseModal}
      onConfirm={onConfirm}
      question={i18n 'generate_plr.confirmation_question'}
      title={i18n 'generate_plr.confirmation_title'}
    />
  </React.Fragment>

GeneratePlrButton.propTypes =
  hasRecommendation: PropTypes.bool
  presentationType: PropTypes.string
  questionId: PropTypes.string.isRequired
  recommendationId: PropTypes.string

GeneratePlrButton.defaultProps =
  hasRecommendation: false
  recommendationId: null

module.exports = ConnectStore GeneratePlrButton, [EtdStore], storeConnectors
